import { Modal } from './UI';

const STATUSES = [
  { group: 'Выход',    items: [{ code: '1', label: '1 — Регулярный выход' }, { code: 'СВ', label: 'СВ — Выход супервайзера' }, { code: 'ПЛ ВЫХ', label: 'ПЛ ВЫХ — Плановый выходной' }] },
  { group: 'Больничный', items: [{ code: 'БЛ-', label: 'БЛ- / не перекрыто' }, { code: 'БЛ+МР', label: 'БЛ+МР / перекрыто МР' }, { code: 'БЛ+ПМ', label: 'БЛ+ПМ / перекрыто ПМ' }, { code: 'БЛ+ВЫХ', label: 'БЛ+ВЫХ / перекроет в вых' }] },
  { group: 'Отпуск',  items: [{ code: 'ОТ-', label: 'ОТ- / не перекрыто' }, { code: 'ОТ+МР', label: 'ОТ+МР / перекрыто МР' }, { code: 'ОТ+ПМ', label: 'ОТ+ПМ / перекрыто ПМ' }, { code: 'ОТ+ВЫХ', label: 'ОТ+ВЫХ / перекроет в вых' }] },
  { group: 'ДО',      items: [{ code: 'ДО-', label: 'ДО- / не перекрыто' }, { code: 'ДО+МР', label: 'ДО+МР / перекрыто МР' }, { code: 'ДО+ПМ', label: 'ДО+ПМ / перекрыто ПМ' }, { code: 'ДО+ВЫХ', label: 'ДО+ВЫХ / перекроет в вых' }] },
  { group: 'Вакансия', items: [{ code: 'ВК-', label: 'ВК- / не перекрыто' }, { code: 'ВК+МР', label: 'ВК+МР / перекрыто МР' }, { code: 'ВК+ПМ', label: 'ВК+ПМ / перекрыто ПМ' }, { code: 'ВК+ВЫХ', label: 'ВК+ВЫХ / перекроет в вых' }] },
];

const STATUS_COLORS = {
  '1':      { bg: '#C6EFCE', fg: '#276221' },
  'СВ':     { bg: '#BDD7EE', fg: '#1F3864' },
  'ПЛ ВЫХ':{ bg: '#EDEDED', fg: '#555' },
  'БЛ-':   { bg: '#FFC7CE', fg: '#9C0006' }, 'БЛ+МР': { bg: '#D6BCF5', fg: '#44337A' }, 'БЛ+ПМ': { bg: '#D6BCF5', fg: '#44337A' }, 'БЛ+ВЫХ': { bg: '#D6BCF5', fg: '#44337A' },
  'ОТ-':   { bg: '#FFE699', fg: '#7D5A00' }, 'ОТ+МР': { bg: '#D6BCF5', fg: '#44337A' }, 'ОТ+ПМ': { bg: '#D6BCF5', fg: '#44337A' }, 'ОТ+ВЫХ': { bg: '#D6BCF5', fg: '#44337A' },
  'ДО-':   { bg: '#FCE4D6', fg: '#843C0C' }, 'ДО+МР': { bg: '#D6BCF5', fg: '#44337A' }, 'ДО+ПМ': { bg: '#D6BCF5', fg: '#44337A' }, 'ДО+ВЫХ': { bg: '#D6BCF5', fg: '#44337A' },
  'ВК-':   { bg: '#E2EFDA', fg: '#375623' }, 'ВК+МР': { bg: '#D6BCF5', fg: '#44337A' }, 'ВК+ПМ': { bg: '#D6BCF5', fg: '#44337A' }, 'ВК+ВЫХ': { bg: '#D6BCF5', fg: '#44337A' },
};

export function getStatusColor(code) {
  return STATUS_COLORS[code] || { bg: '#F0F0F0', fg: '#555' };
}

export function statusShort(code) {
  if (!code) return '';
  if (code === 'ПЛ ВЫХ') return 'ПВ';
  return code.length > 4 ? code.slice(0, 4) : code;
}

// Знак статуса: 1 — несёт визиты и покрывает заказ; -1 — 0 визитов (нужен ТМ);
// 0 — нейтральный (ПЛ ВЫХ); null — статус не проставлен.
export function statusSign(code) {
  if (!code) return null;
  if (code === '1' || code === 'СВ') return 1;
  if (code === 'ПЛ ВЫХ') return 0;
  if (code.endsWith('-') || code.endsWith('−')) return -1;
  return 1; // все «+X» статусы
}

export { STATUSES };

export default function StatusPicker({ open, onClose, onSelect, date, mrcName }) {
  return (
    <Modal open={open} onClose={onClose} title={`${mrcName ? mrcName + ' · ' : ''}${date || ''}`}>
      <div style={{ padding: '0 16px 16px' }}>
        {STATUSES.map(group => (
          <div key={group.group}>
            <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--text-light)', textTransform: 'uppercase', letterSpacing: '.06em', padding: '10px 0 6px' }}>
              {group.group}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
              {group.items.map(item => {
                const c = STATUS_COLORS[item.code] || { bg: '#F0F0F0', fg: '#555' };
                return (
                  <button key={item.code} onClick={() => { onSelect(item.code); onClose(); }}
                    style={{
                      padding: '10px 12px', borderRadius: 8, border: 'none',
                      background: c.bg, color: c.fg, fontWeight: 700,
                      fontSize: 13, textAlign: 'left', cursor: 'pointer',
                    }}>
                    {item.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
        <div style={{ marginTop: 12 }}>
          <button onClick={() => { onSelect(null); onClose(); }}
            style={{
              width: '100%', padding: '10px', borderRadius: 8,
              border: '1.5px solid var(--border)', background: 'white',
              color: 'var(--text-muted)', fontWeight: 600, fontSize: 13,
            }}>
            ✕ Очистить статус
          </button>
        </div>
      </div>
    </Modal>
  );
}
